import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";
import { Notify } from "notiflix";
const DashboardTobbar = () => {
    const [Profileimg, setprofileImg] = useState("");
    const [Balance, setBalance] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/my-profile-image",
                { headers }
            )
            .then((response) => {
                if (response.data.status == true) {
                    setprofileImg(response.data.data.image);
                }

            });
    }, []);
    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/wallet-balance",
                { headers }
            )
            .then((response) => {
                if (response.data.status == true) {
                    setBalance(response.data.data.balance);
                }

            });
    }, []);


    const { language, setLanguage } = useContext(LanguageContext);

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
    };

    const HandleLogout = () => {
        localStorage.removeItem('kkm_auth');
        Notify.success("Logout successfully..!")
        navigate('/')
    }

    return (
        <div className="topbar d-flex justify-content-between align-items-center px-3">
            <div className="language-toggle">
                <span
                    onClick={() => handleLanguageChange("ta")}
                    className={language === "ta" ? "active" : ""}
                >
                    தமிழ்
                </span>
                {" | "}
                <span
                    onClick={() => handleLanguageChange("en")}
                    className={language === "en" ? "active" : ""}
                >
                    English
                </span>
            </div>
            <div className="topbar-layout d-flex align-items-center justify-content-between flex-wrap">
                <div className="mobile-help-line">
                    <strong>{language === "ta" ? "உதவி மையம்" : "Help Line"}</strong> :
                    <span className="ps-2  pe-3">9952676737</span>
                </div>

                <div className="button-row">
                    <button className="login-register-btn" style={{
                        height: "45px",
                        width: "150px",
                        background: 'brown',
                        color: "#fff",
                        border: "none",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "15px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        marginTop: '6px'
                    }}
                        onClick={HandleLogout}>
                        <strong>{language === "ta" ? "வெளியேறு" : "Logout"}</strong>
                    </button>
                    <button
                        className="login-register-btn"
                        style={{
                            height: "45px",
                            width: "150px",
                            background: "linear-gradient(135deg, #28a745, #218838)",
                            color: "#fff",
                            border: "none",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "600",
                            fontSize: "15px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            cursor: "pointer",
                            transition: "all 0.3s ease"
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.background = "linear-gradient(135deg, #218838, #1e7e34)")}
                        onMouseOut={(e) => (e.currentTarget.style.background = "linear-gradient(135deg, #28a745, #218838)")}
                    >
                        💰 Balance: <span style={{ marginLeft: "6px", fontWeight: "bold" }}>{Balance}</span>
                    </button>


                    <div className="logo-image-end"
                        style={{
                            height: '50px',
                            width: '50px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f0f0f0'

                        }}
                    >
                        <img
                            src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${Profileimg}`}
                            alt="profile"
                            style={{
                                height: '100%',
                                width: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default DashboardTobbar;
